import { CSSProperties } from 'react'

const styles: {
  playerRow: CSSProperties
} = {
  playerRow: {
    display: 'flex',
    flexDirection: 'row',
  },
}

export default styles
